import React, { useEffect, useState } from "react";
import GoogleMapReact, { fitBounds } from "google-map-react";
import PinsMarker from "./PinsMarker";

const MapGoogle = (props) => {
  // coordonnees => tableau de localisations
  const { coordonnees, setCountrySelected } = props;

  const zoom = 4;
  const centerLat = 46.227638;
  const centerLng = 2.213749;

  return (
    <div className="MapGoogle" id="MapGoogle">
      <GoogleMapReact
        bootstrapURLKeys={{ key: process.env.REACT_APP_GOOGLEMAP_KEY }}
        center={{
          lat: centerLat,
          lng: centerLng,
        }}
        zoom={zoom}
      >
        {coordonnees
          .filter((item) => item.lat !== "" && item.lng !== "")
          .map((item, index) => (
            <PinsMarker
              setCountrySelected={setCountrySelected ? setCountrySelected : ""}
              localisation={item}
              lat={parseFloat(item.lat)}
              lng={parseFloat(item.lng)}
              key={index}
            />
          ))}
      </GoogleMapReact>
      <span id="blocAfterMap"></span>
    </div>
  );
};

export default MapGoogle;
